import { render } from "./CatalogBuildStatus.vue?vue&type=template&id=4574520d&scoped=true&ts=true"
import script from "./CatalogBuildStatus.vue?vue&type=script&lang=ts"
export * from "./CatalogBuildStatus.vue?vue&type=script&lang=ts"

import "./CatalogBuildStatus.vue?vue&type=style&index=0&id=4574520d&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4574520d"]])

export default __exports__